module.exports = "/static/Images/pt-br/Nine.png";